import React, { memo } from "react"
import { Animated } from "react-animated-css"
import { Typography } from "antd"
const { Title } = Typography

const topics = {
  rjs: {
    title: "Senior React.js Frontend Developer",
    para: "Build exceptional user interfaces with our senior React.js developers — skilled in modern state management, performance optimisation, and scalable component architecture that keeps your frontend fast and maintainable.",
  },
  drd: {
    title: "Microsoft Dynamics 365 F&O Developer",
    para: "Accelerate your Dynamics 365 F&O implementation with specialists in X++, module customisation, and seamless ERP integrations — delivering robust financial and operational systems tailored to your business.",
  },
  ned: {
    title: "Senior .NET / C# Backend Developer",
    para: "Deliver high-performance backend systems with our .NET and C# engineers — experienced in ASP.NET Core, cloud-native architecture, and secure, scalable APIs that power enterprise-grade applications.",
  },
  fed: {
    title: "Flutter Mobile App Developer",
    para: "Ship cross-platform mobile apps faster with our Flutter developers — proficient in Dart, Firebase, and native-feel UI across iOS and Android, with a focus on performance and long-term maintainability.",
  },
  oed: {
    title: "Odoo ERP Developer & Consultant",
    para: "Streamline your operations with our Odoo developers — expert in ERP customisation, workflow automation, Python backend development, and third-party integrations that make your system work the way your business does.",
  },
  aie: {
    title: "AI / ML Engineer",
    para: "Bring AI into your product with our machine learning engineers — specialists in LLM integration, custom model training, RAG pipelines, and production-grade MLOps that turn your data into a competitive advantage.",
  },
}

const defaultContent = {
  title: "Hire the Right Developer for Your Project",
  para: "Tell us your requirements and we will match you with a vetted developer within 48 hours — no lengthy hiring process, no long-term commitment required.",
}

const StaffAugmentationLetsDiscussHeader = ({ data, location }) => {
  const topicKey = location.search.split("=")[1]
  const content = topics[topicKey] || defaultContent
  const backgroundImage = data.bgImage?.childImageSharp.fluid.src

  return (
    <div
      className="top-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="box-wrapper text-and-form-container" style={{ gridTemplateColumns: '1fr', textAlign: 'center' }}>
        <div className="information">
          <Animated
            animationIn="fadeInUp"
            animationInDuration={500}
            animationInDelay={300}
            isVisible={true}
          >
            <Title>{content.title}</Title>
            <br />
            <p>{content.para}</p>
          </Animated>
        </div>
      </div>
    </div>
  )
}

export default memo(StaffAugmentationLetsDiscussHeader)
